import * as config from '../config'

export class Align {
    static scaleToGameW(obj, per) {
        obj.displayWidth = config.width * per;
        obj.scaleY = obj.scaleX;
    }

    static centerHeight(obj) {
        obj.y = config.height / 2;
    }

    static centerWidth(obj) {
        obj.x = config.width / 2
    }

    static center2(obj) {
        obj.x = config.width / 2 - obj.displayWidth / 2;
        obj.y = config.height / 2 - obj.displayHeight / 2;
    }

    static center(obj) {
        obj.x = config.width / 2;
        obj.y = config.height / 2;
    }

}
